import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import { getUserInfo } from './api/user';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue')
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import('@/views/Index.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/index',
          name: 'index',
          component: () => import('@/views/Index.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/course_list',
          name: 'course_list',
          component: () => import('@/views/CourseList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/add_course',
          component: () => import('@/views/AddCourse.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update_course/:id',
          component: () => import('@/views/AddCourse.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/activity_list',
          name: 'activity_list',
          component: () => import('@/views/ActivityList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/add_activity',
          name: 'add_activity',
          component: () => import('@/views/AddActivity.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/school_list',
          name: 'school_list',
          component: () => import('@/views/SchoolList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/add_school',
          component: () => import('@/views/AddSchool.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update_school/:id',
          component: () => import('@/views/AddSchool.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/coach_list/:pageNum',
          name: 'coach_list',
          component: () => import('@/views/CoachList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/add_coach',
          component: () => import('@/views/AddCoach.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update_coach/:id',
          component: () => import('@/views/AddCoach.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/add_coaches',
          component: () => import('@/views/AddCoaches.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/student_list/:pageNum',
          name: 'student_list',
          component: () => import('@/views/StudentList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/student_detail/:id',
          name: 'student_detail',
          component: () => import('@/views/StudentDetail.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/order_list/:pageNum',
          name: 'order_list',
          component: () => import('@/views/OrderList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/order_detail/:id',
          name: 'order_detail',
          component: () => import('@/views/OrderDetail.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/order_detail/:id',
          name: 'order_detail',
          component: () => import('@/views/OrderDetail.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/stock_list/:pageNum',
          name: 'stock_list',
          component: () => import('@/views/StockList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/cert_list/:pageNum',
          name: 'cert_list',
          component: () => import('@/views/CertList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/cert_detail/:id',
          name: 'cert_detail',
          component: () => import('@/views/CertDetail.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/cert_print',
          name: 'cert_print',
          component: () => import('@/views/CertPrint.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/cert_express',
          name: 'cert_express',
          component: () => import('@/views/CertExpress.vue'),
          meta: {
            requiresAuth: true
          }
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const { userId } = store.state.user;
    if (!userId) {
      let uid = localStorage.getItem('userId') || '111';
      let phoneNo = localStorage.getItem('phoneNo') || '';
      getUserInfo(uid).then((res) => {
        if (res.rspCode === 0) {
          let user = {
            userId: res.userId,
            userName: res.userName,
            phoneNo: phoneNo,
            toDoList: res.toDoList
          };
          store.commit('SET_USER', user);
          next();
        } else {
          next({
            name: 'Login',
            path: '/login',
            query: {
              redirect: to.path
            }
          });
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
